// extracted by mini-css-extract-plugin
var _1 = "SwitchView__arrowContainer--Oux3v";
var _2 = "SwitchView__hideArrow--a4Fp6";
var _3 = "SwitchView__main--oWJaY";
var _4 = "SwitchView__mainBottom--ozBkz SwitchView__main--oWJaY";
var _5 = "SwitchView__mainSpace--z8uUz";
var _6 = "SwitchView__standardNext--S8Hx9 SwitchView__arrowContainer--Oux3v";
var _7 = "SwitchView__standardPrevious--cOjgo SwitchView__arrowContainer--Oux3v";
var _8 = "SwitchView__swipe--vQ841 OfficeGeneral__sectionContent--CCJVl OfficeGeneral__gutterLeft--SGn7N OfficeGeneral__gutterRight--jXtq1";
var _9 = "SwitchView__tightNext--XVCPX SwitchView__arrowContainer--Oux3v";
var _a = "SwitchView__tightPrevious--P7Url SwitchView__arrowContainer--Oux3v";
export { _1 as "arrowContainer", _2 as "hideArrow", _3 as "main", _4 as "mainBottom", _5 as "mainSpace", _6 as "standardNext", _7 as "standardPrevious", _8 as "swipe", _9 as "tightNext", _a as "tightPrevious" }
